module.exports = __webpack_public_path__ + "static/media/profile_person.42986b33.png";